import { computed } from 'vue'
import DefaultLogo from '@/components/SVGS/placeholder-advisor-logo.svg'
import { useSessionStore } from '@/store/pinia/SessionStore.ts'
import { getAssetsS3BucketLink } from '@/lib/WhiteLabelHelpers.js'

export function useAdviserPages() {
  const sessionStore = useSessionStore()

  const showPartnerLogo = computed(() => sessionStore.getWhitelabelData.joint_logo)
  const PartnerLogo = computed(() => {
    const identifier = sessionStore.getWhitelabelData?.identifier

    if (!identifier || identifier.trim() === '') {
      return DefaultLogo
    }

    const prefix = String(identifier)
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '-') // Replace non-alphanumeric characters with hyphens

    return `${getAssetsS3BucketLink()}/partner-logos/${prefix}-logo.svg`
  })

  return {
    showPartnerLogo,
    PartnerLogo
  }
}
